import React, { useEffect, useState } from 'react';
import { Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
//import { Link } from 'react-router-dom';
import { NavLink as RouterNavLink } from 'react-router-dom';
import './NavMenu.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CookieManager from '../CookieManager';
import AppRoutes from "../AppRoutes";

const NavMenu = ({ handleLogout }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [user, setUser] = useState({});

  const toggleNavbar = () => setCollapsed(!collapsed);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const token = CookieManager.get();
    if (token) {
      const decodedToken = CookieManager.decode();
      setUser({ userName: decodedToken.userName });
    }
  }, []);

  return (
    <header>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light>
        <NavbarBrand tag={RouterNavLink} to="/">
          <FontAwesomeIcon icon="chart-line" className="me-2" />
          Stats
        </NavbarBrand>

        <NavbarToggler onClick={toggleNavbar} className="mr-2" />

        <Collapse navbar isOpen={!collapsed}>
          <Nav className="me-auto" navbar>
            {AppRoutes
              .filter(r => r.showInMenu)
              .filter(r => !r.roles || CookieManager.isInRoles(r.roles))
              .map(route => (
                <NavItem key={route.path}>
                  <NavLink tag={RouterNavLink} to={route.path} end={route.path === "/"}>
                    <FontAwesomeIcon icon={route.icon} className="me-1" />
                    {route.label}
                  </NavLink>
                </NavItem>
              ))
            }
          </Nav>
          <Nav className="ms-auto" navbar>
            <NavItem>
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret>
                  <FontAwesomeIcon icon="user" className="me-1" />
                  {user.userName}
                </DropdownToggle>

                <DropdownMenu end>
                  <DropdownItem onClick={handleLogout}>
                    Logout
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </NavItem>
          </Nav>

        </Collapse>

      </Navbar>
    </header>
  );
};

export default NavMenu;
